import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { [key: string]: any }) => void;
  data: any;
  activeEvaluationStep: number;
}

export default function ModalReset(props: Props) {
  const modalID = 'validation-reset';

  const { openModal, closeModal } = useModal();
  const { callback, data, activeEvaluationStep } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof openModal === 'string' && openModal === `${modalID}-${data._id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [data._id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title={`Deseja mesmo desfazer sua ${activeEvaluationStep <= 2 ? 'validação' : 'apreciação'}?`}
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: 'reset', task: data });
        closeModal();
      }}
    >
      <p className="m-0">Ao confirmar, a Realização Destaque voltará ao estado inicial de seu nível de apreciação.</p>
    </ConfirmacaoDaAcao>
  );
}
